// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simulate_button_and_loading_container {\n    display: flex;\n    justify-content: center;\n    padding-bottom: 0%;\n    margin-bottom: 4%;\n}\n\n.simulate_button {\n    width: 45%;\n}\n\n.loading_gif {\n    margin-top: -7%;\n    margin-bottom: -7%;\n    width: 20%;\n    height: auto;\n}", ""]);
// Exports
module.exports = exports;
